"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FacebookSquareIcon = FacebookSquareIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function FacebookSquareIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 300 300.00223"
  }, props), /*#__PURE__*/_react.default.createElement("defs", {
    id: "defs4732"
  }, /*#__PURE__*/_react.default.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath4674"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M 0,500 1024,500 1024,0 0,0 0,500 Z",
    id: "path4676"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    id: "layer1",
    transform: "translate(-33.466291,-429.48076)"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "g4670",
    transform: "matrix(1.1165523,0,0,-1.1165523,-103.48743,863.08638)"
  }, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clipPath4674)",
    id: "g4672"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "g4678",
    transform: "translate(375.7163,120.5527)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "m 0,0 c 8.134,0 14.73,6.596 14.73,14.73 l 0,237.434 c 0,8.137 -6.596,14.731 -14.73,14.731 l -237.433,0 c -8.137,0 -14.73,-6.594 -14.73,-14.731 l 0,-237.434 c 0,-8.134 6.593,-14.73 14.73,-14.73 L 0,0 Z",
    fill: "#3b5998",
    fillOpacity: "1",
    fillRule: "nonzero",
    id: "path4680",
    stroke: "none"
  })), /*#__PURE__*/_react.default.createElement("g", {
    id: "g4682",
    transform: "translate(307.7046,120.5527)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "m 0,0 0,103.355 34.693,0 5.194,40.28 -39.887,0 0,25.717 c 0,11.662 3.238,19.609 19.962,19.609 l 21.33,0.01 0,36.026 c -3.69,0.49 -16.351,1.587 -31.081,1.587 -30.753,0 -51.806,-18.771 -51.806,-53.244 l 0,-29.705 -34.781,0 0,-40.28 34.781,0 L -41.595,0 0,0 Z",
    fill: "#fff",
    fillOpacity: "1",
    fillRule: "nonzero",
    id: "path4684",
    stroke: "none"
  }))))));
}